var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-3 mt-md-0 mb-2",attrs:{"height":_vm.$vuetify.breakpoint.smAndDown
      ? 'calc(100vh - 133px)'
      : 'calc(100vh - 100px)',"outlined":""}},[_c('chat',{attrs:{"full-mode":_vm.$vuetify.breakpoint.lgAndUp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }